import React from "react";
import { Button } from "./ui/button";
import { Plus } from "lucide-react";

interface EmptyExerciseStateProps {
  handleAddExercise: () => void;
}

export function EmptyExerciseState({
  handleAddExercise,
}: EmptyExerciseStateProps) {
  return (
    <div className="flex flex-col items-center justify-center p-8 text-center border rounded-lg bg-muted/10">
      <div className="mb-4">
        <div className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-primary/10">
          <Plus className="h-6 w-6 text-primary" />
        </div>
      </div>
      <h3 className="mb-2 text-lg font-medium">No exercises yet</h3>
      <p className="mb-4 text-sm text-muted-foreground max-w-sm">
        Get started by adding your first exercise to this workout.
      </p>
      <Button onClick={handleAddExercise} className="gap-2">
        <Plus className="h-4 w-4" />
        Add Exercise
      </Button>
    </div>
  );
}
